<template>
  <section class="section">
    <h3>{{ $t('message.disease_trend' )}}</h3>
    <div class="container">
      <div class="chart" ref="chart1"></div>
    </div>
    <div class="container">
      <div class="chart" ref="chart2"></div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts/lib/echarts'
import onresize from '@/libraries/onresize'

const AREA_GRADIENT = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
  offset: 0,
  color: 'rgb(255, 158, 68)',
}, {
  offset: 1,
  color: 'rgb(255, 70, 131)',
}])

export default {
  name: 'Charts',
  computed: {
    ...mapState({
      charts: (state) => state.visions.charts || {},
    }),
  },
  methods: {
    paint () {
      const chart1 = echarts.init(this.$refs.chart1, 'line')
      chart1.setOption({
        title: {
          text: this.$t('message.current_confirmed_chart'),
        },
        legend: {
          data: [this.$t('message.current_confirmed_cases'), this.$t('message.current_recovered_cases'), this.$t('message.current_deceased_cases')],
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: this.charts.accumulation.map(({ date }) => date.slice(5)),
          boundaryGap: false,
        },
        yAxis: {},
        series: [{
          type: 'line',
          name: this.$t('message.current_confirmed_cases'),
          data: this.charts.accumulation.map(({ confirmed }) => confirmed),
        }, {
          type: 'line',
          name: this.$t('message.current_recovered_cases'),
          data: this.charts.accumulation.map(({ recovered }) => recovered),
        }, {
          type: 'line',
          name: this.$t('message.current_deceased_cases'),
          data: this.charts.accumulation.map(({ deceased }) => deceased),
        }],
      })

      const chart2 = echarts.init(this.$refs.chart2, 'line')
      chart2.setOption({
        title: {
          text: this.$t('message.increase_confirmed_chart'),
        },
        legend: {
          data: [this.$t('message.increase_confirmed_cases')],
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: this.charts.increased.map(({ date }) => date.slice(5)),
          boundaryGap: false,
        },
        yAxis: {},
        series: [{
          type: 'line',
          name: this.$t('message.increase_confirmed_cases'),
          data: this.charts.increased.map(({ confirmed }) => confirmed),
          areaStyle: {
            color: AREA_GRADIENT,
          },
        }],
      })

      this.chartInstances = [ chart1, chart2 ]
    },
  },
  mounted () {
    this.offresize = onresize(() => (this.chartInstances || []).forEach((chart) => chart.resize()))
  },
  beforeDestroy () {
    this.offresize()
  },
  watch: {
    charts () {
      this.paint()
    },
    '$i18n.locale' () {
      this.paint()
    },
  },
}
</script>

<style lang="less" scoped>
.section {
  border-bottom: 1px solid #f9f9f9;
}
.container {
  position: relative;
  width: 100%;
  height: 280px;
  padding: 24px;
  box-sizing: border-box;
  margin-bottom: 24px;
}
h3 {
  color: #333;
  font-size: 24px;
  font-weight: bold;
  line-height: 1em;
  margin: 1.5em 0;
  padding: 0;
}
.subtitle {
  color: #ccc;
  font-size: 12px;
  margin-bottom: 1em;
}
.chart {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 24px;
  left: 24px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.05);
  background-color: #fff;
}
</style>
